<app-modal [header]="'dataCenterExport.title' | translate">
  <div modal-body class="d-flex flex-column noselect pt-0">
    <p>{{ 'dataCenterExport.message' | translate }}</p>
    <div class="mb-3">
      <strong>{{ 'dataCenterExport.selection_article' | translate }}</strong>
    </div>
    @if (cddArticles()?.length > 1) {
      <div>
        <div class="form-check checkbox mx-1">
          <input
            #selectAllArticlesCheckBox
            class="form-check-input"
            type="checkbox"
            [id]="'select_all'"
            [checked]="true"
            (change)="toggleAllArticlesSelection(selectAllArticlesCheckBox.checked)"
          >
          <label class="form-check-label color-default ms-2" [for]="'select_all'">{{ 'dataCenterExport.select_all' | translate }}</label>
        </div>
        <hr>
      </div>
    }
    <cdk-virtual-scroll-viewport [itemSize]="37" class="overflow-a overflow-xh" [style.min-height.px]="400" [style.max-height.vh]="60">
      <table class="table table-sm table-striped table-hover" style="table-layout: fixed; width: 100%">
        <tbody>
        <tr *cdkVirtualFor="let article of cddArticles()">
          <td (click)="toggleItemSelection(article, $event)">
            <div class="form-check d-flex justify-content-start" style="min-width: 0">
              <input
                class="form-check-input"
                [class.hidden]="!article.cddAvailable"
                type="checkbox"
                [disabled]="!article.cddAvailable"
                [id]="article.articleNo"
                [(ngModel)]="article.isSelected"
              >
              <label
                class="form-check-label text-overflow ps-2"
                [for]="article.articleNo"
                [class.color-default]="article.cddAvailable"
                style="min-width: 0"
                tooltip
                [tooltipText]="article.label"
              >
                {{ article.label }}
              </label>
            </div>
          </td>
          <td style="width: 25px">
            @if (article.cddAvailable) {
              <a tooltip [tooltipText]="'sidebar.search.technical_info' | translate" tooltipPosition="bottom" (click)="showArticleTechnicalInfo(article)">
                <app-svg-icon type="external-link" size="medium-small"/>
              </a>
            }
          </td>
        </tr>
        </tbody>
      </table>
    </cdk-virtual-scroll-viewport>
  </div>
  <ng-container modal-footer>
    <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{ 'global.label.close' | translate }}</button>
    <button type="submit" class="btn btn-primary btn-forward" [disabled]="isRequestDataDisabled()" appActionLogId="dataCenterExport.request_data" (click)="requestData()">{{ 'dataCenterExport.request_data' | translate }}</button>
  </ng-container>
</app-modal>
